import React, { useEffect, useState } from 'react'
import { Breadcrumb, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom";
import { fetchSingleCategory } from '../../../redux/action/category/singleCategory'
import default_image_url from "../../../redux/api/API";
import MainLoading from '../../../utils/MainLoading'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import CreateNewProduct from "./CreateNewProduct";
import { useTranslation } from 'react-i18next'
import './style.scss'

const DashboardProduct = (props) => {
    const dispatch = useDispatch()
    const single_category = useSelector(state => state.single_category)
    const [show, setShow] = useState(false)
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(fetchSingleCategory(props.match.params.id))
    }, [])

    const handleCreateNewProduct = () => {
        setShow(true)
        window.scrollTo(0, 400)
    }

    const update = () => {
        setShow(false)
        setTimeout(function(){dispatch(fetchSingleCategory(props.match.params.id))} , 1000)
    }

    return (
        <Wrapper>
            <DashboardContent>
                <Breadcrumb className='dashboardCategoryBreadcrumb'>
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/dashboard/categories" }} style={{textDecoration: 'none'}}>{t("dashboard_nav_categories")}</Breadcrumb.Item>
                    <Breadcrumb.Item active>{single_category.single_category && single_category.single_category.name}</Breadcrumb.Item>
                </Breadcrumb>
                <DashboardMainTitle> {t("dashboard_nav_category")} {single_category.single_category && single_category.single_category.name} </DashboardMainTitle>
                {single_category.loading ? 
                    <MainLoading /> 
                : 
                   <div>

                        {single_category.single_category.products &&
                            single_category.single_category.products.length ?  
                            <div>
                                <Table responsive bordered>
                                    <thead>
                                        <tr>
                                            <th>{t("picture")}</th>
                                            <th>{t("title")}</th>
                                            <th>{t("brand")}</th>
                                            <th>{t("view counts")}</th>
                                            <th>{t("product_price")}</th>
                                            <th>{t("product_selling_price")}</th>
                                            <th className="text-center">{t("management")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {single_category.single_category.products.map(item => (
                                            <tr key={item.id}>
                                                <td className="text-center">
                                                    {item.photos.length ? 
                                                        item.photos.filter(picture => picture.type === "main").map(picture => 
                                                            <img style={{width: 'auto', height: '70px', objectFit: 'contain'}} alt="product" key={picture.id} src={default_image_url+picture.small_path} />    
                                                        ) 
                                                    : <span style={{fontSize: '.8rem'}}>{t("no image")}</span>}
                                                </td>
                                                <td>{item.name}</td>
                                                <td>{item.brand}</td>
                                                <td>{item.view_count}</td>
                                                <td>{item.price ? parseInt(item.price).toLocaleString() : t("free")}</td>
                                                <td>{item.sell_price ? parseInt(item.sell_price).toLocaleString() : t("free")}</td>
                                                <td className="text-center"><Link className="btn btn-warning btn-sm" to={`/dashboard/product/${item.id}`}> {t("management")} </Link></td>
                                            </tr>
                                        )) }
                                    </tbody>
                                </Table>
                            </div>
                        :
                        <h5 className="text-center">{t("There is no product")}</h5>
                        }

                        <div className="col-12 create_btn my-5 d-flex justify-content-end">
                            <button className="btn btn-success" onClick={handleCreateNewProduct}> {t("create product")} <i className="fa fa-plus"></i></button>
                        </div>
                   </div>
                }

                {show && <CreateNewProduct update={update} id={props.match.params.id} />}

            </DashboardContent>
        </Wrapper>
    )
}

export default DashboardProduct
